import { EventName } from '../constants';
import { createAndSendEvent } from '../jumboClient';

export const IVAChatSummaryBtnClick = (properties = {}) =>
  createAndSendEvent(EventName.IVA_CHAT_SUMMARY_BTN_CLICK, properties);

export const SmartplugChatSummaryBtnClick = (properties = {}) =>
  createAndSendEvent(EventName.SMARTPLUG_CHAT_SUMMARY_BTN_CLICK, properties);

export const IVAResolutionsBtnClick = (properties = {}) =>
  createAndSendEvent(EventName.IVA_RESOLUTIONS_BTN_CLICK, properties);
